// extracted by mini-css-extract-plugin
export default {"logoutSection":"logoutSection-2SjGZ","logoutButton":"logoutButton-1kFlD","centered":"centered-2LOyq"};